<template>
  <div class="loading-overlay">
    <!-- 加载动画类型1：旋转 -->
    <div v-if="loadingStyle === 'spinner'" class="loading-spinner"></div>
    
    <!-- 加载动画类型2：脉冲 -->
    <div v-else-if="loadingStyle === 'pulse'" class="loading-pulse"></div>
    
    <!-- 加载动画类型3：跳动点 -->
    <div v-else-if="loadingStyle === 'dots'" class="loading-dots">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
    
    <!-- 默认回退到spinner -->
    <div v-else class="loading-spinner"></div>
  </div>
</template>

<script>
export default {
  name: 'PageLoading',
  props: {
    loadingStyle: {
      type: String,
      default: 'spinner',
      validator: (value) => {
        return ['spinner', 'pulse', 'dots'].includes(value);
      }
    }
  }
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--page-loading-bg);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(5px);
  animation: fadeIn 0.3s ease forwards;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style> 